export default function getTrailDirectionsUrl(latitude?: string | number, longitude?: string | number) {
  if (!latitude || !longitude) {
    return '';
  }
  return `https://www.google.com/maps/dir/Current+Location/${latitude},${longitude}`;
}
